import { useState, useEffect } from "react";
import { DatePicker, DatePickerInput } from "@carbon/react";
import { useQuery, gql } from "@apollo/client";

// GraphQL for querying the current school year (to limit date selection)
const SCHOOL_YEAR_QUERY = gql`
    query SchoolYearOverview {
        schoolYearOverview {
            startDate
            endDate
        }
    }
`;

/**
 * A reusable holiday date picker component that limits selection to the current school year
 * 
 * @param {Object} props
 * @param {Array} props.value - The selected date range [startDate, endDate]
 * @param {Function} props.onChange - Callback function when dates change
 * @param {Object} props.startProps - Props for the start date input
 * @param {Object} props.endProps - Props for the end date input
 */
export default function HolidayDatePicker({ value, onChange, startProps = {}, endProps = {} }) {
    // Get school year dates to limit selection
    const { data: schoolYearData } = useQuery(SCHOOL_YEAR_QUERY);
    const schoolYearStart = schoolYearData?.schoolYearOverview?.startDate ? new Date(schoolYearData.schoolYearOverview.startDate) : null;
    const schoolYearEnd = schoolYearData?.schoolYearOverview?.endDate ? new Date(schoolYearData.schoolYearOverview.endDate) : null;



    return (
        <DatePicker
            datePickerType="range"
            onChange={onChange}
            dateFormat="d.m.Y"
            value={value}
            minDate={schoolYearStart}
            maxDate={schoolYearEnd}
        >
            <DatePickerInput
                id="holiday-start-date"
                labelText="Startdatum"
                dateFormat="d.m.Y"
            />
            <DatePickerInput
                id="holiday-end-date"
                labelText="Enddatum"
                dateFormat="d.m.Y"
            />
        </DatePicker>
    );
}
